module.exports = {
  "local": {
    "firebase_config": {
      apiKey: "AIzaSyDIrCyIEjEYuTPse1rOpR9Sq8eiqkFCwj4",
      authDomain: "puppet-dev.firebaseapp.com",
      databaseURL: "http://localhost:5001",
      projectId: "puppet-dev",
      storageBucket: "dev-assets.getvidon.com",
      messagingSenderId: "926382906905",
      appId: "1:926382906905:web:e99fd21015882df30e9488",
      measurementId: "G-Q9CLBDLL4N",
      domain: 'localhost:8080',
      video_domain: 'localhost:8080',
    },
    "stripe": {
      key: "pk_test_51HZLdqGJZuvq9y3GNOItTutGA15r1OJx0Yezz1Q3ZWA5awnBsj7rvfNMvG4YeZJ576B4lprrU60DNoc816xBh2m900AmUyHai0",
      trial_price_gb: "price_1HfhuvGJZuvq9y3GjL5Kec1B",
      trial_price_usd: "price_1I7Mq5GJZuvq9y3GJw1wy290",
      trial_price_eur: "price_1I7Mq5GJZuvq9y3GJw1wy290"
    },
    "gmail": {
      api_key: "9m-LSY76jy5n7BmCwjroYiHZ",
      client_id: "926382906905-mjahpckv1v3fstcb4hi8t18mac895aav.apps.googleusercontent.com",
    },
    "demo": {
      project_id: 'fkBfp8jhnhX7rqZmwxtu',
      video_url: 'https://storage.googleapis.com/puppet-dev.appspot.com/media/bf9be2d5-1524-48b0-9a18-cdc0490ca1a9.mp4'
    },
    "fullstory": {
      // org_id: 'YXMTA'
    },
    "hubspot": {
      // site_id: '8904915'
    },
    "segment": {
      // write_key: 'jUkj9H8xnw83trk9YjOfLMS6DH99auuQ'
    },
    "mixpanel": {
      // token: 'c055c12576b6132cdbae00e7a8721b49'
    },
    "algolia": {
      "client": "P7MFWP7BRB",
      "key": "f6b566c72cb623451df1bee290e00f1c"
    }
  },
  "development-local": {
    "firebase_config": {
      apiKey: "AIzaSyDIrCyIEjEYuTPse1rOpR9Sq8eiqkFCwj4",
      authDomain: "puppet-dev.firebaseapp.com",
      databaseURL: "https://puppet-dev.firebaseio.com",
      projectId: "puppet-dev",
      storageBucket: "dev-assets.getvidon.com",
      messagingSenderId: "926382906905",
      appId: "1:926382906905:web:e99fd21015882df30e9488",
      measurementId: "G-Q9CLBDLL4N",
      domain: 'dev-app.vidon.ai',
      video_domain: 'dev-video.getvidon.com',
    },
    "stripe": {
      key: "pk_test_51HZLdqGJZuvq9y3GNOItTutGA15r1OJx0Yezz1Q3ZWA5awnBsj7rvfNMvG4YeZJ576B4lprrU60DNoc816xBh2m900AmUyHai0",
      trial_price_gb: "price_1HfhuvGJZuvq9y3GjL5Kec1B",
      trial_price_usd: "price_1I7Mq5GJZuvq9y3GJw1wy290",
      trial_price_eur: "price_1I7Mq5GJZuvq9y3GJw1wy290"
    },
    "gmail": {
      api_key: "9m-LSY76jy5n7BmCwjroYiHZ",
      client_id: "926382906905-mjahpckv1v3fstcb4hi8t18mac895aav.apps.googleusercontent.com",
    },
    "demo": {
      project_id: 'fkBfp8jhnhX7rqZmwxtu',
      video_url: 'https://storage.googleapis.com/puppet-dev.appspot.com/media/bf9be2d5-1524-48b0-9a18-cdc0490ca1a9.mp4'
    },
    "fullstory": {
      // org_id: 'YXMTA'
    },
    "hubspot": {
      // site_id: '8904915'
    },
    "segment": {
      // write_key: 'jUkj9H8xnw83trk9YjOfLMS6DH99auuQ'
    },
    "mixpanel": {
      // token: 'c055c12576b6132cdbae00e7a8721b49'
    },
    "algolia": {
      "client": "P7MFWP7BRB",
      "key": "f6b566c72cb623451df1bee290e00f1c"
    }
  },
  "development": {
    "firebase_config": {
      apiKey: "AIzaSyDIrCyIEjEYuTPse1rOpR9Sq8eiqkFCwj4",
      authDomain: "puppet-dev.firebaseapp.com",
      databaseURL: "https://puppet-dev.firebaseio.com",
      projectId: "puppet-dev",
      storageBucket: "dev-assets.getvidon.com",
      messagingSenderId: "926382906905",
      appId: "1:926382906905:web:e99fd21015882df30e9488",
      measurementId: "G-Q9CLBDLL4N",
      domain: 'dev-app.vidon.ai',
      video_domain: 'dev-video.getvidon.com',
    },
    "stripe": {
      key: "pk_test_51HZLdqGJZuvq9y3GNOItTutGA15r1OJx0Yezz1Q3ZWA5awnBsj7rvfNMvG4YeZJ576B4lprrU60DNoc816xBh2m900AmUyHai0",
      trial_price_gb: "price_1HfhuvGJZuvq9y3GjL5Kec1B",
      trial_price_usd: "price_1I7Mq5GJZuvq9y3GJw1wy290",
      trial_price_eur: "price_1I7Mq5GJZuvq9y3GJw1wy290"
    },
    "gmail": {
      api_key: "9m-LSY76jy5n7BmCwjroYiHZ",
      client_id: "926382906905-mjahpckv1v3fstcb4hi8t18mac895aav.apps.googleusercontent.com",
    },
    "demo": {
      project_id: 'fkBfp8jhnhX7rqZmwxtu',
      video_url: 'https://storage.googleapis.com/puppet-dev.appspot.com/media/bf9be2d5-1524-48b0-9a18-cdc0490ca1a9.mp4'
    },
    "fullstory": {
      // org_id: 'YXMTA'
    },
    "hubspot": {
      // site_id: '8904915'
    },
    "segment": {
      // write_key: 'jUkj9H8xnw83trk9YjOfLMS6DH99auuQ'
    },
    "mixpanel": {
      // token: 'c055c12576b6132cdbae00e7a8721b49'
    },
    "algolia": {
      "client": "P7MFWP7BRB",
      "key": "f6b566c72cb623451df1bee290e00f1c"
    }
  },
  "production": {
    "firebase_config": {
      apiKey: "AIzaSyBQO6JXlCEUeN0row7SqGysZytMEpbpaNA",
      authDomain: "doli-prod.firebaseapp.com",
      databaseURL: "https://doli-prod.firebaseio.com",
      projectId: "doli-prod",
      storageBucket: "assets.getvidon.com",
      messagingSenderId: "357126837621",
      appId: "1:357126837621:web:8ea1d46c66782740f9ef3c",
      measurementId: "G-HRP6STXLCE",
      domain: 'app.vidon.ai',
      video_domain: 'vidon.video',
    },
    "stripe": {
      key: "pk_live_51HZLdqGJZuvq9y3GmMx6NEjcYHtlikTETeF4MrCS28XkULjjSXrRq5KJXovbQGPyMd0jZAXJbGmkEMmXBL8r6ABR00y2e1Pthb",
      trial_price_gb: "price_1IVJo6GJZuvq9y3GIrpd79oy",
      trial_price_usd: "price_1IVJnmGJZuvq9y3GoN441sho",
      trial_price_eur: "price_1IUBQ5GJZuvq9y3GsPTW9yPP"
    },
    "gmail": {
      api_key: "pYJEiXeSxncaLt9KocbtTwc",
      client_id: "357126837621-bduvtnojqd0m34ibo1bmj8cpro2f7mjs.apps.googleusercontent.com",
    },
    "demo": {
      project_id: 'rSoNVAg48thDrx10j5TD',
      video_url: 'https://firebasestorage.googleapis.com/v0/b/puppet-dev.appspot.com/o/ycW6iC3rFKSi9RXUTcFr1byW6Ub2%2Fvideos%2Fcyu4JJF4AfpmWRJS70TB?alt=media&token=a798d0e2-fb54-4629-821d-b2eaff1764d3'
    },
    "fullstory": {
      org_id: 'YXMTA'
    },
    "hubspot": {
      site_id: '8904915'
    },
    "segment": {
      write_key: 'jUkj9H8xnw83trk9YjOfLMS6DH99auuQ'
    },
    "mixpanel": {
      token: 'c055c12576b6132cdbae00e7a8721b49'
    },
    "algolia": {
      "client": "SROQHG3TFR",
      "key": "9c65472dbeb2a4cbd82fdbbc8954acd3"
    }
  }
}
